import { render, staticRenderFns } from "./TestingHistoryTableList.vue?vue&type=template&id=0d7b0020&scoped=true"
import script from "./TestingHistoryTableList.vue?vue&type=script&lang=js"
export * from "./TestingHistoryTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b0020",
  null
  
)

export default component.exports